// Opens WhatsApp / LinkedIn links in a new tab, leaving LegalApp open in this one.
// If the browser blocks the new tab, the link's own target="_blank" still applies.
export default function openExternal(e) {
  const a = e && e.currentTarget;
  if (!a || !a.href) return;
  const w = window.open(a.href, '_blank');
  if (w) {
    try {
      w.opener = null;
    } catch {
      // already cross-origin
    }
    e.preventDefault();
    console.log(`[LegalApp] opened ${a.href.split('?')[0]} in a new tab`);
  } else {
    console.log('[LegalApp] new tab was blocked; following the link instead');
  }
}
